import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft, BookOpen, Play } from 'lucide-react'

import { knowledgeBaseItems } from '../../components/knowledge-base/knowledgeBaseData'
import { Footer, Header } from '../../components/landing'
import { longFormRichTextClassName } from '../../utils/richText'

const KnowledgeBaseDetailPage = () => {
    const { articleId } = Route.useParams()
    const item = knowledgeBaseItems.find((i) => i.id === articleId)

    if (!item) {
        return (
            <div className="min-h-screen bg-off-white font-sans text-brand-dark">
                <Header />
                <main className="flex flex-col items-center justify-center py-24">
                    <h1 className="mb-4 text-2xl font-bold">A cikk nem található</h1>
                    <Link to="/knowledge-base" className="text-primary hover:underline">
                        Vissza a Tudásbázishoz
                    </Link>
                </main>
                <Footer />
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main className="flex flex-col">
                <section className="bg-white py-24">
                    <div className="mx-auto w-full max-w-[860px] px-6">
                        <Link
                            to="/knowledge-base"
                            className="mb-8 inline-flex items-center gap-2 text-sm font-medium text-primary transition-colors hover:text-primary/80"
                        >
                            <ArrowLeft className="h-4 w-4" />
                            Vissza a Tudásbázishoz
                        </Link>

                        <div className="mb-6 flex items-center gap-2">
                            <div
                                className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider shadow-sm ${
                                    item.type === 'video'
                                        ? 'bg-brand-yellow text-brand-dark'
                                        : 'bg-primary text-white'
                                }`}
                            >
                                {item.type === 'video' ? (
                                    <Play className="h-3 w-3" />
                                ) : (
                                    <BookOpen className="h-3 w-3" />
                                )}
                                {item.type === 'video' ? 'Videó' : 'Cikk'}
                            </div>
                        </div>

                        <h1 className="mb-6 text-3xl font-bold text-brand-dark md:text-4xl">
                            {item.title}
                        </h1>

                        <p className="mb-12 text-lg leading-relaxed text-brand-gray">
                            {item.summary}
                        </p>

                        {item.type === 'video' && item.youtubeVideoId ? (
                            <div className="mb-12 overflow-hidden rounded-2xl">
                                <div
                                    className="relative w-full"
                                    style={{ paddingBottom: '56.25%' }}
                                >
                                    <iframe
                                        allowFullScreen
                                        className="absolute inset-0 h-full w-full"
                                        src={`https://www.youtube.com/embed/${item.youtubeVideoId}`}
                                        title={item.title}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    />
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="mb-12">
                                    <img
                                        alt={item.title}
                                        className="h-auto max-h-[70vh] w-full rounded-2xl object-contain"
                                        src={item.imageUrl}
                                    />
                                </div>
                                {item.content && (
                                    <div
                                        className={longFormRichTextClassName}
                                        dangerouslySetInnerHTML={{ __html: item.content }}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export const Route = createFileRoute('/knowledge-base/$articleId')({
    head: () => ({
        meta: [{ title: 'Long-Y - Tudástár' }],
    }),
    component: KnowledgeBaseDetailPage,
    loader: async ({ context }) => {
        await context.apiUtils.webContent.getAllPublic.ensureData()
    },
})
